import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CpdEntry } from '../../../model/CpdEntry';
@Component({
    selector: 'app-cpd-entry-annotations',
    templateUrl: './cpdEntryAnnotations.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CpdEntryAnnotationsComponent {

  @Input() cpdEntry!: CpdEntry;

}
